"use server";

import { GRP_ROLE_ADMIN } from "@/lib/grp";
import { requireServerRole } from "@/lib/guards";
import {
  addBodyworkerProtocolListSchema,
  deleteBodyworkerProtocolListSchema,
  editBodyworkerProtocolListSchema,
} from "@/lib/schemas/bodyworker-protocol-lists";
import { validateParams } from "@/lib/utils";
import { prisma } from "@/prisma";
import { ActionResult } from "@/types/server-action";
import z from "zod";

export async function deleteBodyworkerProtocolList(
  params: z.infer<typeof deleteBodyworkerProtocolListSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { id } = validateParams(deleteBodyworkerProtocolListSchema, params);

    await prisma.bodyworkerProtocolList.update({
      where: { id },
      data: { deletedAt: new Date() },
    });

    return { success: true };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function addBodyworkerProtocolList(
  params: z.infer<typeof addBodyworkerProtocolListSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const {
      kvps,
      commercialDenomination,
      postalCode,
      siren,
      commercialProtocol,
    } = validateParams(addBodyworkerProtocolListSchema, params);

    const bodyworkerProtocolList = await prisma.bodyworkerProtocolList.create({
      data: {
        kvps,
        commercialDenomination,
        postalCode,
        siren,
        commercialProtocol,
        isActive: true,
      },
    });

    return { success: true, data: bodyworkerProtocolList };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function editBodyworkerProtocolList(
  params: z.infer<typeof editBodyworkerProtocolListSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const {
      id = -1,
      kvps,
      commercialDenomination,
      postalCode,
      siren,
      commercialProtocol,
      isActive = true,
    } = validateParams(editBodyworkerProtocolListSchema, params);

    const bodyworkerProtocolList = await prisma.bodyworkerProtocolList.update({
      where: { id },
      data: {
        kvps,
        commercialDenomination,
        postalCode,
        siren,
        commercialProtocol,
        isActive,
      },
    });

    return { success: true, data: bodyworkerProtocolList };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
